import { render } from "./ChevronLeftIcon16.vue.js?vue&type=template&id=4c1af1f2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ChevronLeftIcon16.vue?vue&type=template&id=4c1af1f2"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__